import { useRef, useState } from "react";
import { ImagePlus } from "lucide-react";

// Drop zone for bookmaker screenshots: drag images onto the card or use the Scan button inside it.
export function ShotDrop({ onFiles, busy, children, testId }) {
  const [over, setOver] = useState(false);
  const depth = useRef(0);
  const images = (list) => [...(list || [])].filter((f) => /^image\/(png|jpeg|webp)$/.test(f.type));
  return (
    <div className={`shot-drop ${over ? "is-over" : ""}`} data-testid={testId}
      onDragEnter={(e) => { e.preventDefault(); depth.current += 1; setOver(true); }}
      onDragLeave={() => { depth.current -= 1; if (depth.current <= 0) { depth.current = 0; setOver(false); } }}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => { e.preventDefault(); depth.current = 0; setOver(false); const f = images(e.dataTransfer.files); if (f.length && !busy) onFiles(f); }}>
      {children}
      <p className="shot-drop-hint" data-testid={`${testId}-hint`}><ImagePlus size={13} />{busy ? "Reading screenshot…" : "Drag & drop a screenshot here"}</p>
      {over && <div className="shot-drop-overlay"><ImagePlus size={22} />Drop to read the lines</div>}
    </div>
  );
}
